import React from 'react'

import classNames from 'classnames'
import { Link } from 'react-router-dom'

interface Props {
  label: string
  icon?: React.ElementType
  iconName?: string
  iconSize?: string
  selected?: boolean
  onClick?: () => void
  href?: string
  external?: boolean
  newTab?: boolean
  iconWidth?: string
  iconHeight?: string
  rightContent?: React.ReactElement | string
  className?: string
}

const SideNavItem: React.FC<Props> = ({
  label,
  icon: Icon,
  selected,
  onClick,
  href,
  external,
  newTab,
  iconHeight,
  iconWidth,
  iconName,
  iconSize,
  rightContent,
  className: externalClassName,
}: Props) => {
  const className = `flex flex-row items-center px-4 py-2 sm:py-1.5 w-full rounded ${
    selected ? 'bg-white bg-opacity-20' : 'hover:bg-white hover:bg-opacity-20'
  } ${externalClassName}`
  const content = (
    <>
      {Icon && (
        <span className="w-[16px] flex flex-col items-center mr-2.5">
          <Icon className={`text-white ${iconHeight ?? 'h-3.5'} ${iconWidth ?? 'w-3.5'}`} />
        </span>
      )}
      {iconName && (
        <span className="w-[16px] flex flex-col items-center mr-2.5">
          <i className={classNames('nf-icon', iconName, iconSize ?? 'text-lg')} />
        </span>
      )}
      <span className="text-base ellipsify flex-1 text-left">{label}</span>
      {rightContent && <span>{rightContent}</span>}
    </>
  )

  if (href) {
    return (
      <Link
        to={href}
        className={className}
        target={newTab ? '_blank' : '_self'}
        reloadDocument={external}>
        {content}
      </Link>
    )
  }
  return (
    <button type="button" onClick={onClick} className={className}>
      {content}
    </button>
  )
}

export default SideNavItem
